const bespokeServerAppMockupsHtml = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Bespoke Server App — Style Explorations</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Nunito:wght@400;600;700;800&display=swap');

*{margin:0;padding:0;box-sizing:border-box}

body{
  background:#111;
  color:#fff;
  font-family:system-ui,-apple-system,sans-serif;
  padding:40px 20px;
}

h1{
  text-align:center;
  font-size:28px;
  font-weight:700;
  margin-bottom:8px;
  letter-spacing:-0.5px;
}
.subtitle{
  text-align:center;
  font-size:14px;
  color:#888;
  margin-bottom:40px;
}

.grid-wrapper{
  display:grid;
  grid-template-columns:80px repeat(3,375px);
  grid-template-rows:40px repeat(3,812px);
  gap:24px;
  justify-content:center;
  align-items:start;
}

/* Column headers */
.col-header{
  text-align:center;
  font-size:16px;
  font-weight:700;
  letter-spacing:1px;
  text-transform:uppercase;
  display:flex;
  align-items:end;
  justify-content:center;
  padding-bottom:8px;
}
.col-header.fitbit{color:#00B4D8}
.col-header.strava{color:#FC4C02}
.col-header.snackpass{color:#FF2D78}

/* Row labels */
.row-label{
  writing-mode:vertical-lr;
  transform:rotate(180deg);
  font-size:13px;
  font-weight:600;
  letter-spacing:2px;
  text-transform:uppercase;
  color:#666;
  display:flex;
  align-items:center;
  justify-content:center;
}

/* Phone frame */
.phone{
  width:375px;
  height:812px;
  border-radius:40px;
  overflow:hidden;
  box-shadow:0 8px 40px rgba(0,0,0,0.5), 0 0 0 3px #333;
  position:relative;
}

/* Spacer for top-left corner of grid */
.corner{grid-column:1;grid-row:1}

.footer{
  text-align:center;
  font-size:12px;
  color:#555;
  margin-top:40px;
  padding-bottom:40px;
}

/* ========== FITBIT STYLE ========== */
.fitbit-screen{
  font-family:'Inter',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.fitbit-screen .status-bar{
  display:flex;justify-content:space-between;padding:14px 24px 8px;
  font-size:12px;color:#999;font-weight:500;
}
.fitbit-screen .nav-bottom{
  display:flex;justify-content:space-around;padding:12px 0 28px;
  border-top:1px solid #eee;margin-top:auto;
}
.fitbit-screen .nav-bottom span{
  font-size:10px;color:#999;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;
}
.fitbit-screen .nav-bottom span.active{color:#00B4D8}

/* Fitbit Home */
.fitbit-home .greeting{padding:20px 24px 0;font-size:22px;font-weight:700;color:#1a1a1a}
.fitbit-home .greeting span{font-weight:400;color:#888;font-size:14px;display:block;margin-top:4px}

.ring-container{display:flex;justify-content:center;padding:32px 0 24px}
.ring-svg{width:200px;height:200px}
.ring-bg{fill:none;stroke:#E8F8FB;stroke-width:12}
.ring-fg{fill:none;stroke:#00B4D8;stroke-width:12;stroke-linecap:round;transform:rotate(-90deg);transform-origin:center;transition:stroke-dashoffset 0.5s}
.ring-text{font-family:'Inter',sans-serif;fill:#1a1a1a;font-weight:700;font-size:36px;text-anchor:middle}
.ring-sub{font-family:'Inter',sans-serif;fill:#999;font-size:13px;text-anchor:middle}

.fitbit-stat-row{display:flex;justify-content:space-around;padding:0 24px 20px}
.fitbit-stat{text-align:center}
.fitbit-stat .val{font-size:22px;font-weight:700;color:#00B4D8}
.fitbit-stat .label{font-size:11px;color:#999;margin-top:2px}

.fitbit-card{background:#F8FAFB;border-radius:16px;margin:0 20px 12px;padding:16px 20px}
.fitbit-card .card-title{font-size:12px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:8px}
.fitbit-card .card-val{font-size:28px;font-weight:700;color:#1a1a1a}
.fitbit-card .card-val span{color:#00B4D8}

/* Fitbit Challenge */
.fitbit-challenge .section-title{padding:20px 24px 16px;font-size:20px;font-weight:700}
.fitbit-progress-bar{height:8px;background:#E8F8FB;border-radius:4px;margin:0 24px 24px;overflow:hidden}
.fitbit-progress-bar .fill{height:100%;background:#00B4D8;border-radius:4px;width:60%}

.attempt-list{padding:0 24px}
.attempt-item{display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid #f0f0f0}
.attempt-item .num{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600}
.attempt-item .num.done{background:#E8F8FB;color:#00B4D8}
.attempt-item .num.pending{background:#f5f5f5;color:#ccc}
.attempt-item .detail{flex:1}
.attempt-item .detail .time{font-size:13px;font-weight:600;color:#1a1a1a}
.attempt-item .detail .sub{font-size:11px;color:#999}
.attempt-item .status{font-size:18px}

.fitbit-info{margin:20px 24px;padding:16px;background:#F8FAFB;border-radius:12px}
.fitbit-info .info-title{font-size:13px;font-weight:600;color:#1a1a1a;margin-bottom:6px}
.fitbit-info .info-text{font-size:12px;color:#888;line-height:1.5}

/* Fitbit Leaderboard */
.fitbit-lb .toggle-bar{display:flex;gap:0;margin:16px 24px 20px;background:#f0f0f0;border-radius:8px;overflow:hidden}
.fitbit-lb .toggle-bar button{flex:1;padding:8px;border:none;background:transparent;font-size:12px;font-weight:600;color:#999;cursor:pointer;font-family:'Inter',sans-serif}
.fitbit-lb .toggle-bar button.active{background:#fff;color:#00B4D8;box-shadow:0 1px 4px rgba(0,0,0,0.08)}

.lb-list{padding:0 24px}
.lb-item{display:flex;align-items:center;gap:12px;padding:14px 0;border-bottom:1px solid #f0f0f0}
.lb-item.me{background:#F0FAFB;margin:0 -24px;padding:14px 24px;border-radius:0}
.lb-rank{font-size:16px;font-weight:700;width:24px;color:#999}
.lb-item.me .lb-rank{color:#00B4D8}
.lb-avatar{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#fff}
.lb-info{flex:1}
.lb-name{font-size:14px;font-weight:600;color:#1a1a1a}
.lb-sub{font-size:11px;color:#999}
.lb-stat{text-align:right}
.lb-stat .val{font-size:16px;font-weight:700;color:#1a1a1a}
.lb-stat .label{font-size:10px;color:#999}

/* ========== STRAVA STYLE ========== */
.strava-screen{
  font-family:system-ui,-apple-system,sans-serif;
  background:#1a1a2e;
  color:#fff;
  height:100%;
  display:flex;
  flex-direction:column;
}
.strava-screen .status-bar{
  display:flex;justify-content:space-between;padding:14px 24px 8px;
  font-size:12px;color:#666;font-weight:500;
}
.strava-screen .nav-bottom{
  display:flex;justify-content:space-around;padding:12px 0 28px;
  border-top:1px solid #2a2a4e;margin-top:auto;
}
.strava-screen .nav-bottom span{
  font-size:10px;color:#666;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;
}
.strava-screen .nav-bottom span.active{color:#FC4C02}

/* Strava Home */
.strava-home .header{padding:16px 24px;display:flex;justify-content:space-between;align-items:center}
.strava-home .header h2{font-size:14px;font-weight:600;color:#888;text-transform:uppercase;letter-spacing:1px}
.strava-home .header .date{font-size:12px;color:#555}

.strava-activity-card{margin:0 20px 16px;background:linear-gradient(135deg,#2a2a4e 0%,#1e1e3a 100%);border-radius:16px;padding:24px;border:1px solid #333366}
.strava-activity-card .label{font-size:12px;color:#888;text-transform:uppercase;letter-spacing:1px;margin-bottom:12px}
.strava-activity-card .big-stat{font-size:48px;font-weight:800;color:#FC4C02;line-height:1}
.strava-activity-card .big-label{font-size:16px;color:#ccc;margin-top:4px;font-weight:500}

.segment-bar{margin:20px 20px 0;background:#2a2a4e;border-radius:8px;height:12px;overflow:hidden}
.segment-bar .fill{height:100%;background:linear-gradient(90deg,#FC4C02,#FF6B35);border-radius:8px;width:60%}
.segment-label{display:flex;justify-content:space-between;padding:8px 20px 0;font-size:11px;color:#888}

.strava-stats{display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;padding:24px 20px}
.strava-stat-item{background:#2a2a4e;border-radius:12px;padding:16px;text-align:center}
.strava-stat-item .val{font-size:20px;font-weight:700;color:#fff}
.strava-stat-item .label{font-size:10px;color:#888;margin-top:4px;text-transform:uppercase}

.kudos-btn{margin:0 20px;padding:14px;background:transparent;border:2px solid #FC4C02;border-radius:12px;color:#FC4C02;font-size:14px;font-weight:700;cursor:pointer;text-align:center;font-family:system-ui}

/* Strava Challenge */
.strava-challenge .segment-card{margin:16px 20px;background:linear-gradient(135deg,#FC4C02 0%,#e04400 50%,#c03800 100%);border-radius:20px;padding:28px 24px}
.strava-challenge .segment-card .seg-label{font-size:11px;text-transform:uppercase;letter-spacing:2px;color:rgba(255,255,255,0.7);margin-bottom:8px}
.strava-challenge .segment-card h2{font-size:24px;font-weight:800;line-height:1.2;margin-bottom:16px}
.strava-challenge .segment-card .pr{font-size:13px;color:rgba(255,255,255,0.8)}
.strava-challenge .segment-card .pr strong{color:#fff}

.effort-list{padding:0 24px;margin-top:20px}
.effort-item{display:flex;align-items:center;gap:12px;padding:14px 0;border-bottom:1px solid #2a2a4e}
.effort-dot{width:10px;height:10px;border-radius:50%}
.effort-dot.success{background:#FC4C02}
.effort-dot.pending{background:#333366}
.effort-detail{flex:1}
.effort-detail .time{font-size:14px;font-weight:600}
.effort-detail .sub{font-size:11px;color:#666}
.effort-status{font-size:13px;font-weight:600}
.effort-status.success{color:#FC4C02}
.effort-status.pending{color:#444}

.strava-pr-card{margin:20px;padding:16px;background:#2a2a4e;border-radius:12px;display:flex;align-items:center;gap:12px}
.strava-pr-card .icon{font-size:28px}
.strava-pr-card .pr-info .title{font-size:13px;font-weight:600}
.strava-pr-card .pr-info .sub{font-size:11px;color:#888}

/* Strava Leaderboard */
.strava-lb .club-header{padding:20px 24px;font-size:18px;font-weight:800;display:flex;align-items:center;gap:8px}
.strava-lb .toggle-bar{display:flex;gap:0;margin:0 24px 20px;background:#2a2a4e;border-radius:8px;overflow:hidden}
.strava-lb .toggle-bar button{flex:1;padding:8px;border:none;background:transparent;font-size:12px;font-weight:600;color:#666;cursor:pointer;font-family:system-ui}
.strava-lb .toggle-bar button.active{background:#FC4C02;color:#fff}

.strava-lb-list{padding:0 24px}
.strava-lb-item{display:flex;align-items:center;gap:12px;padding:16px 0;border-bottom:1px solid #2a2a4e}
.strava-lb-item.me{background:#2a2a4e;margin:0 -24px;padding:16px 24px;border-left:3px solid #FC4C02}
.strava-lb-item .rank{font-size:18px;font-weight:800;width:28px;color:#666}
.strava-lb-item.me .rank{color:#FC4C02}
.strava-lb-item .avatar{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700}
.strava-lb-item .info{flex:1}
.strava-lb-item .name{font-size:14px;font-weight:700}
.strava-lb-item .sub{font-size:11px;color:#666}
.strava-lb-item .bar-wrap{width:80px}
.strava-lb-item .bar{height:6px;background:#333366;border-radius:3px;overflow:hidden}
.strava-lb-item .bar .fill{height:100%;background:#FC4C02;border-radius:3px}
.strava-lb-item .count{font-size:16px;font-weight:800;width:30px;text-align:right}

/* ========== SNACKPASS STYLE ========== */
.snackpass-screen{
  font-family:'Nunito',system-ui,sans-serif;
  background:#FFFFFF;
  color:#1a1a1a;
  height:100%;
  display:flex;
  flex-direction:column;
}
.snackpass-screen .status-bar{
  display:flex;justify-content:space-between;padding:14px 24px 8px;
  font-size:12px;color:#999;font-weight:600;
}
.snackpass-screen .nav-bottom{
  display:flex;justify-content:space-around;padding:12px 0 28px;
  border-top:1px solid #f0f0f0;margin-top:auto;
}
.snackpass-screen .nav-bottom span{
  font-size:10px;color:#bbb;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:700;
}
.snackpass-screen .nav-bottom span.active{color:#FF2D78}

/* Snackpass Home */
.snackpass-home .challenge-card{
  margin:12px 20px;
  background:linear-gradient(135deg,#FF2D78 0%,#FF6B9D 50%,#FFD600 100%);
  border-radius:24px;
  padding:28px 24px;
  color:#fff;
}
.snackpass-home .challenge-card .emoji-big{font-size:48px;margin-bottom:12px;display:block}
.snackpass-home .challenge-card h2{font-size:22px;font-weight:800;margin-bottom:8px}
.snackpass-home .challenge-card .progress-stars{font-size:28px;letter-spacing:4px;margin:12px 0}
.snackpass-home .challenge-card .progress-text{font-size:15px;font-weight:700}

.tip-pill{
  margin:16px auto;
  display:inline-flex;
  padding:10px 24px;
  background:linear-gradient(135deg,#FFD600,#FFC107);
  border-radius:50px;
  font-size:16px;
  font-weight:800;
  color:#1a1a1a;
}
.tip-pill-wrap{text-align:center}

.streak-badge{
  margin:8px auto;
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:8px 20px;
  background:#FFF5F8;
  border-radius:50px;
  font-size:14px;
  font-weight:700;
  color:#FF2D78;
}
.streak-wrap{text-align:center;margin-bottom:8px}

.snackpass-quick-stats{display:grid;grid-template-columns:1fr 1fr;gap:12px;padding:8px 20px}
.snackpass-quick-stat{background:#FFF5F8;border-radius:20px;padding:16px;text-align:center}
.snackpass-quick-stat .val{font-size:24px;font-weight:800;color:#FF2D78}
.snackpass-quick-stat .label{font-size:11px;color:#999;font-weight:600;margin-top:4px}

.snackpass-feed-item{margin:12px 20px;background:#FAFAFA;border-radius:20px;padding:16px;display:flex;align-items:center;gap:12px}
.snackpass-feed-item .emoji{font-size:32px}
.snackpass-feed-item .text{font-size:13px;font-weight:600;color:#555}
.snackpass-feed-item .text strong{color:#1a1a1a}

/* Snackpass Challenge */
.snackpass-challenge .challenge-header{
  margin:12px 20px;
  background:linear-gradient(135deg,#FF2D78,#FFD600);
  border-radius:24px;
  padding:28px 24px;
  text-align:center;
  color:#fff;
}
.snackpass-challenge .challenge-header .emoji{font-size:56px;margin-bottom:12px;display:block}
.snackpass-challenge .challenge-header h2{font-size:22px;font-weight:800}

.stamp-row{display:flex;justify-content:center;gap:12px;padding:24px 20px}
.stamp{width:56px;height:56px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:24px}
.stamp.done{background:linear-gradient(135deg,#FF2D78,#FF6B9D);color:#fff;box-shadow:0 4px 12px rgba(255,45,120,0.3)}
.stamp.pending{background:#f0f0f0;color:#ddd;border:2px dashed #ddd}

.snackpass-reward-card{
  margin:12px 20px;
  background:linear-gradient(135deg,#FFF5F8,#FFF9E6);
  border-radius:20px;
  padding:20px;
  text-align:center;
  border:2px solid #FFD600;
}
.snackpass-reward-card .emoji{font-size:36px;margin-bottom:8px;display:block}
.snackpass-reward-card .title{font-size:15px;font-weight:800;color:#FF2D78}
.snackpass-reward-card .sub{font-size:12px;color:#999;margin-top:4px}

.snackpass-attempt-list{padding:0 24px;margin-top:8px}
.snackpass-attempt{display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid #f5f5f5}
.snackpass-attempt .emoji{font-size:20px}
.snackpass-attempt .detail{flex:1}
.snackpass-attempt .detail .time{font-size:13px;font-weight:700}
.snackpass-attempt .detail .sub{font-size:11px;color:#999}
.snackpass-attempt .badge{padding:4px 12px;border-radius:50px;font-size:11px;font-weight:700}
.snackpass-attempt .badge.done{background:#E8FFE8;color:#22C55E}
.snackpass-attempt .badge.miss{background:#FFF0F0;color:#FF4444}

/* Snackpass Leaderboard */
.snackpass-lb .battle-header{padding:16px 24px 8px;font-size:20px;font-weight:800;text-align:center}
.snackpass-lb .toggle-pills{display:flex;justify-content:center;gap:8px;padding:8px 20px 16px}
.snackpass-lb .toggle-pills button{
  padding:8px 20px;border:none;border-radius:50px;font-size:12px;font-weight:700;cursor:pointer;font-family:'Nunito',sans-serif;
}
.snackpass-lb .toggle-pills button.active{background:linear-gradient(135deg,#FF2D78,#FF6B9D);color:#fff}
.snackpass-lb .toggle-pills button:not(.active){background:#f0f0f0;color:#999}

.snackpass-podium{display:flex;justify-content:center;align-items:end;gap:16px;padding:16px 20px 24px}
.podium-card{text-align:center;border-radius:24px;padding:20px 16px;width:110px}
.podium-card.first{background:linear-gradient(135deg,#FFD600,#FFC107);transform:scale(1.1);box-shadow:0 8px 24px rgba(255,214,0,0.3)}
.podium-card.second{background:linear-gradient(135deg,#FF2D78,#FF6B9D);color:#fff}
.podium-card.third{background:#f0f0f0}
.podium-card .avatar-emoji{font-size:36px;display:block;margin-bottom:8px}
.podium-card .name{font-size:13px;font-weight:800}
.podium-card .stat{font-size:11px;font-weight:600;margin-top:4px}
.podium-card .stat-val{font-size:20px;font-weight:800;margin-top:4px}
.podium-card.first .name{color:#1a1a1a}
.podium-card.first .stat{color:#7a6800}
.podium-card.second .stat{color:rgba(255,255,255,0.8)}
.podium-card.third .name{color:#555}
.podium-card.third .stat{color:#999}

.cheer-section{padding:8px 24px}
.cheer-item{display:flex;align-items:center;gap:12px;padding:12px 0;border-bottom:1px solid #f5f5f5}
.cheer-item .emoji{font-size:24px}
.cheer-item .text{flex:1;font-size:13px;font-weight:600;color:#555}
.cheer-item .cheer-btn{
  padding:6px 16px;background:#FFF5F8;border:2px solid #FF2D78;border-radius:50px;
  font-size:12px;font-weight:700;color:#FF2D78;cursor:pointer;font-family:'Nunito',sans-serif;
}

</style>
</head>
<body>

<h1>Bespoke Server App — Style Explorations</h1>
<p class="subtitle">The Grove, San Francisco — Upsell 5 Arnold Palmers challenge</p>

<div class="grid-wrapper">
  <!-- Corner spacer -->
  <div class="corner"></div>

  <!-- Column headers -->
  <div class="col-header fitbit">Fitbit</div>
  <div class="col-header strava">Strava</div>
  <div class="col-header snackpass">Snackpass</div>

  <!-- ===== ROW 1: HOME / DASHBOARD ===== -->
  <div class="row-label">Home</div>

  <!-- FITBIT HOME -->
  <div class="phone">
    <div class="fitbit-screen fitbit-home">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="greeting">Good afternoon, Sarah<span>Lunch Shift · 11am–3pm</span></div>
      <div class="ring-container">
        <svg class="ring-svg" viewBox="0 0 200 200">
          <circle class="ring-bg" cx="100" cy="100" r="80"/>
          <circle class="ring-fg" cx="100" cy="100" r="80" stroke-dasharray="502.65" stroke-dashoffset="201.06"/>
          <text class="ring-text" x="100" y="96">3/5</text>
          <text class="ring-sub" x="100" y="118">Arnold Palmers</text>
        </svg>
      </div>
      <div class="fitbit-card">
        <div class="card-title">Tip Boost Today</div>
        <div class="card-val"><span>+$8.40</span></div>
      </div>
      <div class="fitbit-stat-row">
        <div class="fitbit-stat"><div class="val">3</div><div class="label">Attempts</div></div>
        <div class="fitbit-stat"><div class="val">56%</div><div class="label">Close Rate</div></div>
        <div class="fitbit-stat"><div class="val">2nd</div><div class="label">Rank</div></div>
      </div>
      <div class="nav-bottom">
        <span class="active">◉ Home</span>
        <span>◎ Challenge</span>
        <span>◎ Board</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA HOME -->
  <div class="phone">
    <div class="strava-screen strava-home">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="header"><h2>Today's Activity</h2><div class="date">Tue, Mar 18</div></div>
      <div class="strava-activity-card">
        <div class="label">Arnold Palmers Sold</div>
        <div class="big-stat">3</div>
        <div class="big-label">of 5 target</div>
      </div>
      <div style="padding:0 20px">
        <div class="segment-bar"><div class="fill"></div></div>
        <div class="segment-label"><span>0</span><span>Challenge: 5</span></div>
      </div>
      <div class="strava-stats">
        <div class="strava-stat-item"><div class="val">56%</div><div class="label">Close Rate</div></div>
        <div class="strava-stat-item"><div class="val">+$8.40</div><div class="label">Tip Boost</div></div>
        <div class="strava-stat-item"><div class="val">2nd</div><div class="label">Rank</div></div>
      </div>
      <button class="kudos-btn">👊 Give Kudos to Team</button>
      <div class="nav-bottom">
        <span class="active">◉ Feed</span>
        <span>◎ Segments</span>
        <span>◎ Club</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS HOME -->
  <div class="phone">
    <div class="snackpass-screen snackpass-home">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="challenge-card">
        <span class="emoji-big">🍋</span>
        <h2>Today's Challenge!</h2>
        <div class="progress-stars">⭐⭐⭐☆☆</div>
        <div class="progress-text">3 of 5 Arnold Palmers 🎯</div>
      </div>
      <div class="tip-pill-wrap"><div class="tip-pill">💰 Tip Boost: +$8.40 today!</div></div>
      <div class="streak-wrap"><div class="streak-badge">🔥 Streak: 4 days</div></div>
      <div class="snackpass-quick-stats">
        <div class="snackpass-quick-stat"><div class="val">56%</div><div class="label">Close Rate</div></div>
        <div class="snackpass-quick-stat"><div class="val">2nd</div><div class="label">Today's Rank</div></div>
      </div>
      <div class="snackpass-feed-item">
        <div class="emoji">🎉</div>
        <div class="text"><strong>Mike</strong> just sold an Arnold Palmer! You're neck and neck!</div>
      </div>
      <div class="nav-bottom">
        <span class="active">◉ Home</span>
        <span>◎ Quests</span>
        <span>◎ Board</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 2: CHALLENGE DETAIL ===== -->
  <div class="row-label">Challenge</div>

  <!-- FITBIT CHALLENGE -->
  <div class="phone">
    <div class="fitbit-screen fitbit-challenge">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="section-title">Shift Challenge</div>
      <div class="fitbit-card">
        <div class="card-title">Arnold Palmer Upsell</div>
        <div class="card-val">3 <span>/ 5</span></div>
      </div>
      <div class="fitbit-progress-bar"><div class="fill"></div></div>
      <div class="attempt-list">
        <div class="attempt-item">
          <div class="num done">1</div>
          <div class="detail"><div class="time">11:23 AM — Table 4</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="status">✓</div>
        </div>
        <div class="attempt-item">
          <div class="num done">2</div>
          <div class="detail"><div class="time">11:51 AM — Table 7</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="status">✓</div>
        </div>
        <div class="attempt-item">
          <div class="num done">3</div>
          <div class="detail"><div class="time">12:15 PM — Table 2</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="status">✓</div>
        </div>
        <div class="attempt-item">
          <div class="num pending">4</div>
          <div class="detail"><div class="time">Pending</div><div class="sub">Est. +$2.80</div></div>
          <div class="status" style="color:#ddd">–</div>
        </div>
        <div class="attempt-item">
          <div class="num pending">5</div>
          <div class="detail"><div class="time">Pending</div><div class="sub">Est. +$2.80</div></div>
          <div class="status" style="color:#ddd">–</div>
        </div>
      </div>
      <div class="fitbit-info">
        <div class="info-title">How it works</div>
        <div class="info-text">Suggest an Arnold Palmer to guests ordering drinks. Each successful upsell adds an estimated $2.80 to your tips based on average check increase and tip rate.</div>
      </div>
      <div class="nav-bottom">
        <span>◎ Home</span>
        <span class="active">◉ Challenge</span>
        <span>◎ Board</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA CHALLENGE -->
  <div class="phone">
    <div class="strava-screen strava-challenge">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="segment-card">
        <div class="seg-label">Segment Challenge</div>
        <h2>Arnold Palmer Upsell Sprint</h2>
        <div class="pr">Personal Best: <strong>5/5 (last Tuesday)</strong></div>
      </div>
      <div style="padding:0 20px;margin-top:16px">
        <div class="segment-bar"><div class="fill"></div></div>
        <div class="segment-label"><span>3 completed</span><span>2 remaining</span></div>
      </div>
      <div class="effort-list">
        <div class="effort-item">
          <div class="effort-dot success"></div>
          <div class="effort-detail"><div class="time">11:23 AM — Table 4</div><div class="sub">Sold · +$2.80 boost</div></div>
          <div class="effort-status success">✓ Sold</div>
        </div>
        <div class="effort-item">
          <div class="effort-dot success"></div>
          <div class="effort-detail"><div class="time">11:51 AM — Table 7</div><div class="sub">Sold · +$2.80 boost</div></div>
          <div class="effort-status success">✓ Sold</div>
        </div>
        <div class="effort-item">
          <div class="effort-dot success"></div>
          <div class="effort-detail"><div class="time">12:15 PM — Table 2</div><div class="sub">Sold · +$2.80 boost</div></div>
          <div class="effort-status success">✓ Sold</div>
        </div>
        <div class="effort-item">
          <div class="effort-dot pending"></div>
          <div class="effort-detail"><div class="time">Awaiting next attempt</div><div class="sub">Est. +$2.80</div></div>
          <div class="effort-status pending">–</div>
        </div>
        <div class="effort-item">
          <div class="effort-dot pending"></div>
          <div class="effort-detail"><div class="time">Awaiting next attempt</div><div class="sub">Est. +$2.80</div></div>
          <div class="effort-status pending">–</div>
        </div>
      </div>
      <div class="strava-pr-card">
        <div class="icon">🏅</div>
        <div class="pr-info">
          <div class="title">2 away from matching your PR!</div>
          <div class="sub">Last Tuesday you hit 5/5 — go for it again</div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Feed</span>
        <span class="active">◉ Segments</span>
        <span>◎ Club</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS CHALLENGE -->
  <div class="phone">
    <div class="snackpass-screen snackpass-challenge">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="challenge-header">
        <span class="emoji">🍹</span>
        <h2>Arnold Palmer Challenge</h2>
      </div>
      <div class="stamp-row">
        <div class="stamp done">✅</div>
        <div class="stamp done">✅</div>
        <div class="stamp done">✅</div>
        <div class="stamp pending">☆</div>
        <div class="stamp pending">☆</div>
      </div>
      <div class="snackpass-reward-card">
        <span class="emoji">🏆</span>
        <div class="title">Complete all 5 to unlock Shift MVP badge!</div>
        <div class="sub">You're 2 away — keep going!</div>
      </div>
      <div class="snackpass-attempt-list">
        <div class="snackpass-attempt">
          <div class="emoji">🍋</div>
          <div class="detail"><div class="time">11:23 AM — Table 4</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="badge done">Sold!</div>
        </div>
        <div class="snackpass-attempt">
          <div class="emoji">🍋</div>
          <div class="detail"><div class="time">11:51 AM — Table 7</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="badge done">Sold!</div>
        </div>
        <div class="snackpass-attempt">
          <div class="emoji">🍋</div>
          <div class="detail"><div class="time">12:15 PM — Table 2</div><div class="sub">+$2.80 tip boost</div></div>
          <div class="badge done">Sold!</div>
        </div>
        <div class="snackpass-attempt">
          <div class="emoji">⏳</div>
          <div class="detail"><div class="time">Next upsell</div><div class="sub">Est. +$2.80</div></div>
          <div class="badge miss">Waiting</div>
        </div>
        <div class="snackpass-attempt">
          <div class="emoji">⏳</div>
          <div class="detail"><div class="time">Next upsell</div><div class="sub">Est. +$2.80</div></div>
          <div class="badge miss">Waiting</div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Home</span>
        <span class="active">◉ Quests</span>
        <span>◎ Board</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 3: LEADERBOARD / SOCIAL ===== -->
  <div class="row-label">Leaderboard</div>

  <!-- FITBIT LEADERBOARD -->
  <div class="phone">
    <div class="fitbit-screen fitbit-lb">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div style="padding:20px 24px 0;font-size:20px;font-weight:700">Leaderboard</div>
      <div class="toggle-bar">
        <button>Week</button>
        <button>Day</button>
        <button class="active">Shift</button>
      </div>
      <div class="lb-list">
        <div class="lb-item">
          <div class="lb-rank">1</div>
          <div class="lb-avatar" style="background:#00B4D8">M</div>
          <div class="lb-info"><div class="lb-name">Mike R.</div><div class="lb-sub">4 Arnold Palmers · 67% close</div></div>
          <div class="lb-stat"><div class="val">4</div><div class="label">sold</div></div>
        </div>
        <div class="lb-item me">
          <div class="lb-rank">2</div>
          <div class="lb-avatar" style="background:#0090A8">S</div>
          <div class="lb-info"><div class="lb-name">Sarah T. (You)</div><div class="lb-sub">3 Arnold Palmers · 56% close</div></div>
          <div class="lb-stat"><div class="val">3</div><div class="label">sold</div></div>
        </div>
        <div class="lb-item">
          <div class="lb-rank">3</div>
          <div class="lb-avatar" style="background:#66D4E8">J</div>
          <div class="lb-info"><div class="lb-name">Jamie L.</div><div class="lb-sub">2 Arnold Palmers · 50% close</div></div>
          <div class="lb-stat"><div class="val">2</div><div class="label">sold</div></div>
        </div>
      </div>
      <div class="fitbit-card" style="margin-top:24px">
        <div class="card-title">Your Shift Stats</div>
        <div style="display:flex;justify-content:space-between;margin-top:8px">
          <div><div style="font-size:11px;color:#999">Upsells</div><div style="font-size:18px;font-weight:700">3</div></div>
          <div><div style="font-size:11px;color:#999">Close Rate</div><div style="font-size:18px;font-weight:700">56%</div></div>
          <div><div style="font-size:11px;color:#999">Est. Tips</div><div style="font-size:18px;font-weight:700;color:#00B4D8">+$8.40</div></div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Home</span>
        <span>◎ Challenge</span>
        <span class="active">◉ Board</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- STRAVA LEADERBOARD -->
  <div class="phone">
    <div class="strava-screen strava-lb">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="club-header">🏪 The Grove Club</div>
      <div class="toggle-bar">
        <button>Weekly</button>
        <button class="active">Today</button>
      </div>
      <div style="padding:0 24px 12px;font-size:11px;color:#666;text-transform:uppercase;letter-spacing:1px">Arnold Palmers Sold — Lunch Shift</div>
      <div class="strava-lb-list">
        <div class="strava-lb-item">
          <div class="rank">1</div>
          <div class="avatar" style="background:#FC4C02;color:#fff">👑</div>
          <div class="info"><div class="name">Mike R.</div><div class="sub">4 sold · 67% close rate</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:100%"></div></div></div>
          <div class="count">4</div>
        </div>
        <div class="strava-lb-item me">
          <div class="rank">2</div>
          <div class="avatar" style="background:#e04400;color:#fff">S</div>
          <div class="info"><div class="name">Sarah T. (You)</div><div class="sub">3 sold · 56% close rate</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:75%"></div></div></div>
          <div class="count">3</div>
        </div>
        <div class="strava-lb-item">
          <div class="rank">3</div>
          <div class="avatar" style="background:#333366;color:#888">J</div>
          <div class="info"><div class="name">Jamie L.</div><div class="sub">2 sold · 50% close rate</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:50%"></div></div></div>
          <div class="count">2</div>
        </div>
      </div>
      <div style="padding:24px 20px">
        <button class="kudos-btn" style="width:100%">👊 Give Kudos to Mike</button>
      </div>
      <div class="strava-pr-card">
        <div class="icon">📊</div>
        <div class="pr-info">
          <div class="title">1 behind leader — you can catch up!</div>
          <div class="sub">~1h 45m left in your shift</div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Feed</span>
        <span>◎ Segments</span>
        <span class="active">◉ Club</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- SNACKPASS LEADERBOARD -->
  <div class="phone">
    <div class="snackpass-screen snackpass-lb">
      <div class="status-bar"><span>12:47 PM</span><span>LTE &nbsp; 84%</span></div>
      <div class="battle-header">Today's Shift Battle 🥊</div>
      <div class="toggle-pills">
        <button class="active">Today</button>
        <button>This Week</button>
      </div>
      <div class="snackpass-podium">
        <div class="podium-card second">
          <span class="avatar-emoji">💪</span>
          <div class="name">Sarah (You)</div>
          <div class="stat">Arnold Palmers</div>
          <div class="stat-val">3</div>
        </div>
        <div class="podium-card first">
          <span class="avatar-emoji">👑</span>
          <div class="name">Mike</div>
          <div class="stat">Arnold Palmers</div>
          <div class="stat-val">4</div>
        </div>
        <div class="podium-card third">
          <span class="avatar-emoji">🔥</span>
          <div class="name">Jamie</div>
          <div class="stat">Arnold Palmers</div>
          <div class="stat-val">2</div>
        </div>
      </div>
      <div style="padding:0 24px 8px;font-size:12px;font-weight:700;color:#999">Activity</div>
      <div class="cheer-section">
        <div class="cheer-item">
          <div class="emoji">🍋</div>
          <div class="text"><strong>Mike</strong> sold an Arnold Palmer 2 min ago</div>
          <button class="cheer-btn">👏 Cheer</button>
        </div>
        <div class="cheer-item">
          <div class="emoji">🍋</div>
          <div class="text"><strong>You</strong> sold an Arnold Palmer at 12:15 PM</div>
          <button class="cheer-btn">🎉 Nice!</button>
        </div>
        <div class="cheer-item">
          <div class="emoji">🎯</div>
          <div class="text"><strong>Jamie</strong> is 3 away from the challenge goal</div>
          <button class="cheer-btn">💪 Go!</button>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Home</span>
        <span>◎ Quests</span>
        <span class="active">◉ Board</span>
        <span>◎ Me</span>
      </div>
    </div>
  </div>
</div>

<p class="footer">Concept mockups for design partner discussion — March 2026</p>

</body>
</html>`;

export default bespokeServerAppMockupsHtml;
